import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1)
    },
    root: {
      width: "100%",
      backgroundColor: theme.palette.background.paper
    },
    title: {
      fontSize: "1.3rem",
      fontWeight: "bold",
      color: theme.palette.primary.main
    },
    listItem: {
      fontSize: "1.1rem",
      fontWeight: 500,
      color: theme.palette.text.secondary
    },
    nested: {
      paddingLeft: theme.spacing(4)
    }
  })
);
